<template>
  <div class="profil-container" v-if="finish && finish.length > 0">
    <h3 class="profil-title">
      <span v-if="isEdit" class="editRow" @click="editRow(finish[0])"><span
          class="fa fa-edit pointer ml20"></span></span>
      {{ finish[0].text }}
    </h3>
    <p class="profil-subtitle">
      <span v-if="isEdit" class="editRow" @click="editRow(finish[1])"><span
          class="fa fa-edit pointer ml20"></span></span>
      {{ finish[1].text }}
    </p>

    <div class="profil-btn-wrapper">
      <div @click="endLandingPage()" class="btn-landing">
        Selesai
      </div>
      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div>

    <EditPertanyaan v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
  </div>
</template>

<script>
export default {
  components: {
    EditPertanyaan: () => import('@/components/masterdata/landing-page/edit/edit-pertanyaan.vue'),
    AddPertanyaan: () => import('@/components/masterdata/landing-page/add/tambah-pertanyaan.vue'),
  },
  props: {
    isEdit: Boolean
  },
  data() {
    return {
      showModalEdit: false,
      showModalAdd: false,
      editData: null
    }
  },
  computed: {
    finish() {
      const data = this.$store.state.mdLandingStore.finish
      return data
    }
  },
  methods: {
    editRow(data) {
      this.editData = data
      this.showModalEdit = true
    },

    addQuestion() {
      this.showModalAdd = true;
    },

    closeModalAdd() {
      this.showModalAdd = false;
    },

    closeModal() {
      this.showModalEdit = false
    },

    endLandingPage() {
      // no action
    },


    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitasbu')
    },
  },
}
</script>
